import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "80px 20px",
            color: "#95B2C5",
            textAlign: "center",
          }}
        >
          <h2 style={{ color: "#ffffff", margin: "0 0 8px 0" }}>
            Something went wrong
          </h2>
          <p style={{ margin: 0, fontSize: "0.9rem", opacity: 0.8 }}>
            We couldn't load this page due to an unexpected error. Please try again later.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
